<template>
  <!-- 登录 -->
  <div id="house-login" class="layui-fulid">
    <div class="layui-form">
      <p>登录CSON</p>
      <div v-if="accountLogin">
        <div class="layui-input-block login">
          <h2><img src="@/assets/img/icon-user.png" />邮箱/手机号</h2>
          <el-input
            v-model="account"
            class="layui-input"
            placeholder="请输入邮箱/手机号"
            type="text"
          />
        </div>
        <div class="layui-input-block login">
          <h2><img src="@/assets/img/icon-password.png" />登录密码</h2>
          <el-input
            v-model="password"
            class="layui-input"
            placeholder="请输入登录密码"
            type="password"
          />
        </div>
      </div>
      <div v-else>
        <div class="layui-input-block login">
          <h2><img src="@/assets/img/icon-user.png" />手机号</h2>
          <el-input
            v-model="phoneNumber"
            class="layui-input"
            placeholder="手机号"
            type="text"
          >
            <el-select
              v-model="areaCode"
              slot="prepend"
              placeholder="请选择区号"
              style="width: 130px"
              value-key="val"
            >
              <el-option
                v-for="item in countrys"
                :key="item.val"
                :label="item.label"
                :value="item.val"
              >
              </el-option>
            </el-select>
          </el-input>
        </div>
        <div class="layui-input-block login">
          <h2><img src="@/assets/img/icon-password.png" />验证码</h2>
          <el-input
            v-model="validateCode"
            class="layui-input"
            placeholder="请输入验证码"
            style="width: 63%"
          >
          </el-input>
          <el-button
            style="
              width: 35%;
              margin: 0;
              margin-left: 2%;
              vertical-align: top;
              padding: 0;
              font-size: 16px;
              background: #fff;
            "
            :disabled="sended"
            @click="sendVerificationCode"
            >{{ sended ? `${countDown}秒后再次发送` : "发送验证码" }}</el-button
          >
        </div>
      </div>

      <div class="else">
        <!-- <div class="le">
                  <input type="checkbox" /> 7天自动登录
                </div>-->
        <div
          class="rg"
          @click="accountLogin = !accountLogin"
          style="margin-right: 12px; float: left"
        >
          {{ accountLogin ? "验证码登录" : "密码登录" }}
        </div>
        <div
          class="rg"
          v-if="accountLogin"
          @click="findpassword"
          style="float: right"
        >
          找回密码
        </div>
      </div>
      <button class="layui-btn login" lay-filter="user-login" @click="login">
        登录
      </button>
      <div class="other">
        <img src="@/assets/img/other-login.png" />
      </div>
      <button
        class="layui-btn register"
        @click="goregister"
        lay-submit
        lay-filter="user-login"
      >
        微信扫码快速登录
      </button>
      <div class="no-account">
        没有账号?
        <router-link to="/registerform">
          <a>立即注册</a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  applyLogin,
  sendVerificationCode,
  verifyCodeLogin,
} from "../../service/index";
import { getIn, validEmail } from "../../utils/index";

export default {
  data() {
    return {
      account: "",
      password: "",
      // account: "asen666",
      // password: "123456",
      isLoading: false,
      accountLogin: true,
      phoneNumber: "",
      validateCode: "",
      countrys: [
        {
          label: "+1 美国 & 加拿大",
          val: "1",
        },
        {
          label: "+86 中国",
          val: "86",
        },
        {
          label: "+886 台湾",
          val: "886",
        },
        {
          label: "+852 香港",
          val: "852",
        },
        {
          label: "+61 澳大利亚",
          val: "61",
        },
        {
          label: "+44 英国",
          val: "44",
        },
        {
          label: "+49 德国",
          val: "49",
        },
        {
          label: "+353 爱尔兰",
          val: "353",
        },
        {
          label: "+41 瑞士",
          val: "41",
        },
        {
          label: "+31 荷兰",
          val: "31",
        },
        {
          label: "+33 法国",
          val: "33",
        },
        {
          label: "+34 西班牙",
          val: "34",
        },
        {
          label: "+64 新西兰",
          val: "64",
        },
        {
          label: "+7 俄罗斯",
          val: "7",
        },
        {
          label: "+82 韩国",
          val: "82",
        },
        {
          label: "+81 日本",
          val: "81",
        },
        {
          label: "+971 阿拉伯联合酋长国",
          val: "971",
        },
      ],
      areaCode: "86",
      countDown: 60,
      sended: false,
    };
  },
  created() {
    let that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if (
        that.$route.path == "/login" &&
        (e.code == "Enter" || e.code == "enter")
      ) {
        //验证在登录界面和按得键是回车键enter
        that.login(); //登录函数
      }
    };
  },
  methods: {
    async login() {
      if (this.isLoading) {
        return;
      }
      if (this.accountLogin) {
        if (this.account.length == 0) {
          this.$message.closeAll();
          this.$message.error("邮箱/手机号不能为空");
          return;
        }
        // if (!validEmail(this.account)) {
        //   this.$message.closeAll();
        //   this.$message.error("请输入合法邮箱");
        //   return;
        // }
        if (!this.password) {
          this.$message.closeAll();
          this.$message.warning("请输入密码");
          return;
        }
        this.isLoading = true;
        applyLogin({
          phoneOrEmail: this.account,
          password: this.password,
        }).then((res) => {
          if (res.success) {
            this.$message.success("登录成功");
            window.localStorage.setItem("CSON_PAGE_TOKEN", res.result.token);
            if (res.result.hasEmail) {
              setTimeout(() => {
                window.location.href = "/";
                this.isLoading = false;
              }, 1500);
            } else {
              this.$message.warning("请先完善个人信息");
              this.$router.push("/bindEmail");
            }
          } else {
            this.isLoading = false;
            this.$message.closeAll();
            this.$message.error(res.message);
          }
        });
      } else {
        if (this.phoneNumber == "") {
          this.$message.closeAll();
          this.$message.error("手机号不能为空");
          return;
        }
        if (this.validateCode == "") {
          this.$message.closeAll();
          this.$message.warning("请输入验证码");
          return;
        }
        this.isLoading = true;
        verifyCodeLogin({
          phoneOrEmail: `${this.areaCode}${this.phoneNumber}`,
          code: this.validateCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success("登录成功");
            window.localStorage.setItem("CSON_PAGE_TOKEN", res.result.token);

            if (res.result.hasEmail) {
              setTimeout(() => {
                window.location.href = "/";
                this.isLoading = false;
              }, 1500);
            } else {
              this.$message.warning("请先完善个人信息");
              this.$router.push("/bindEmail");
            }
          } else {
            this.isLoading = false;
            this.$message.closeAll();
            this.$message.error(res.message);
          }
        });
      }
    },
    findpassword() {
      this.$router.push("/findpassword");
    },
    goregister() {
      this.$router.push("/wechatRegister");
    },
    sendVerificationCode() {
      if (this.phoneNumber == "") {
        return this.$message.error("请输入手机号码！");
      }
      sendVerificationCode(`${this.areaCode}${this.phoneNumber}`).then(
        (res) => {
          if (res.success) {
            this.$message.success("发送验证码成功！");
            this.sended = true;
            const countDown = setInterval(() => {
              this.countDown = this.countDown - 1;
              if (this.countDown == 0) {
                clearInterval(countDown);
                this.countDown = 60;
                this.sended = false;
              }
            }, 1000);
          }
        }
      );
    },
  },
};
</script>
<style scoped>
::v-deep .el-input-group__append {
  line-height: 42px;
  height: 42px;
}
::v-deep .el-select input {
  height: inherit !important;
  margin-bottom: 0 !important;
}
::v-deep .el-input__inner {
  margin-bottom: 0;
}
</style>
